const MyselfOptionValues = {
    MySelf: "MySelf",
    MySelf_Id: "MySelfId",
}
export default MyselfOptionValues
